<script setup lang="ts">
import Markdown from '../../../core/components/markdown/Markdown.vue';
import Icon from "@/core/components/icon/Icon.vue";

defineProps<{ hook: string }>();


</script>

<template>
  <div class="flex flex-col md:flex-row justify-between gap-y-4 gap-x-8 px-4 py-4 md:items-center rounded-lg bg-white">
    <div class="flex flex-row items-baseline gap-4 relative shrink-0">
      <img src="@/assets/icons/metro-bubbles.svg" class="h-10" alt="Bubbles">
      <span class="font-semibold text-lg bottom-1 relative">
        Engagez la conversation...
      </span>
    </div>
    <div class="flex rounded-lg bg-pink-lighter md:max-w-[60%]">
      <div class="relative flex flex-1">
        <div class="absolute top-0 left-2">
          <icon name="mdi-format-quote-open" :size="35" />
        </div>
        <div class="font-content mx-12">
          <markdown :content="hook" class="text-sm leading-normal text-center" />
        </div>
        <div class="absolute bottom-0 right-2">
          <icon name="mdi-format-quote-close" :size="35" />
        </div>
      </div>
    </div>
  </div>
</template>
